/**
 * One nook (block 03).
 *
 * Separate from `useNooks` so the detail route imports only what it renders —
 * the ISP claim in this block's spec. Block 14 makes this the call that
 * triggers lazy summary generation, which is another reason it is not a
 * selector over the list cache: opening a nook has to be a request.
 */
import { useQuery } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { processingRefetch } from "../processing.js";
import { queryKeys } from "../query-keys.js";
export function useNook(id) {
    return useQuery({
        queryKey: queryKeys.nooks.detail(id),
        queryFn: () => getNookClient().getNook(id),
        // A 404 is an answer — a deleted or foreign nook — not a blip.
        retry: (failureCount, error) => !(error instanceof Error && "status" in error && error.status === 404) &&
            failureCount < 2,
        // Extraction lands in a worker, so an open panel has to watch for it rather
        // than wait to be told (block 08) — and from block 14 so does the summary,
        // which the same open is what asked for. One burst covers both: a nook
        // whose extraction finishes into a summary never stops polling in between,
        // and the ceiling is still counted once.
        refetchInterval: (query) => processingRefetch(query.queryHash, query.state.dataUpdateCount, query.state.data?.status === "processing" ||
            query.state.data?.summaryPending === true),
    });
}
//# sourceMappingURL=use-nook.js.map